import {Suspense, lazy} from 'react';
import SuspenseFallback from '../SuspenseFallback';

const App = lazy(() => import('./index'));

export default () => {
    return (
        <Suspense fallback={<SuspenseFallback />}>
            <App />
        </Suspense>
    );
};
